import photoImage from '../image/photo-pro.png';
import './about.css';

function About() {
	return (
		<section id='about' className='sectionAbout py-5'>
			<div className='container'>
				<div className='row align-items-center'>
					<div className='col-12 col-md-6 mb-4 mb-md-0'>
						<img
							src={photoImage}
							alt='Profil'
							className='img-fluid rounded'
						/>
					</div>
					<div className='col-12 col-md-6'>
						<div className='card-body position-relative'>
							<h1 className='big'>À propos</h1>
							<h1 className='mb-3 small'>À propos de moi</h1>
							<p className='card-text text'>
								Titulaire d'un BTS SIO option SLAM (Solutions
								Logicielles et Applications Métiers), je suis
								passionnée par le développement web et la
								conception d'applications. Au cours de ma
								formation et de mes deux années d'alternance,
								j'ai développé des compétences en développement
								full-stack à travers des projets en Java,
								Laravel, React et WordPress. Aujourd'hui, je
								souhaite poursuivre mes études en Bachelor
								Développeur IA Agentique afin d'approfondir mes
								compétences en développement logiciel et en
								intelligence artificielle, tout en continuant à
								concevoir des applications innovantes.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default About;
